import { render, staticRenderFns } from "./baseTableTree.vue?vue&type=template&id=2e0a231c&scoped=true"
import script from "./baseTableTree.vue?vue&type=script&lang=js"
export * from "./baseTableTree.vue?vue&type=script&lang=js"
import style0 from "./baseTableTree.vue?vue&type=style&index=0&id=2e0a231c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e0a231c",
  null
  
)

export default component.exports